import React from 'react';

const SvgHopCardTilted = ({ title, ...props }) => (
  <svg width={76.078} height={55.188} {...props}>
    {title ? <title>{title}</title> : null}
    <g data-name="Group 627">
      <g data-name="Group 625">
        <path
          data-name="Path 897"
          d="M66.459.334L2.03 11.715a2.06 2.06 0 00-1.671 2.39l.846 4.79 68.489-12.1-.846-4.79a2.06 2.06 0 00-2.39-1.671z"
          fill="#fff"
        />
      </g>
      <path
        data-name="Path 898"
        d="M1.205 18.894L7.26 53.172a2.06 2.06 0 002.389 1.67l64.428-11.38a2.06 2.06 0 001.672-2.388L69.694 6.796z"
        fill="#270089"
      />
      <g data-name="Group 626">
        <path
          data-name="Path 899"
          d="M46.014 37.483s-12.151-3.968-26.522 4.76c0 0 17.664-6.099 27.471.615z"
          fill="#ff6b00"
        />
        <path
          data-name="Path 900"
          d="M36.044 35.53a35.229 35.229 0 016.119-.016 6.444 6.444 0 003.914-7.166 6.616 6.616 0 00-7.957-5.287c-3.757.663-6.39 3.846-5.71 7.701a6.324 6.324 0 003.634 4.768zm2.853-9.146a3.226 3.226 0 11-2.615 3.737 3.226 3.226 0 012.615-3.737z"
          fill="#fff"
        />
        <path
          data-name="Path 901"
          d="M25.3 38.067l-.956-5.41c-.418-2.364.397-3.592 1.91-3.859a2.2 2.2 0 012.549 2.04l1.015 5.748q1.471-.384 2.963-.65c.302-.053.6-.1.897-.146l-1.142-6.466c-.543-3.074-2.804-4.764-5.635-4.264a5.185 5.185 0 00-3.51 2.204l-1.492-8.441-3.904.69 3.578 20.252a40.65 40.65 0 013.726-1.698z"
          fill="#fff"
        />
        <path
          data-name="Path 902"
          d="M51.784 21.019a8.502 8.502 0 00-3.044 1.17l-.17-.968-3.9.689 3.657 20.702 3.898-.688-1.47-8.327a7.647 7.647 0 003.084.072 6.602 6.602 0 005.66-7.692c-.68-3.856-4.007-5.613-7.715-4.958zm1.661 9.346a3.224 3.224 0 01-3.68-2.366l-.088-.503a3.224 3.224 0 113.768 2.869z"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

export default SvgHopCardTilted;
